'use es6';

import { getFlattenedTeamsMap } from 'ui-asset-management-lib/utils/TeamUtils';
import { USERS_AND_TEAMS_TYPE } from 'AdsUI/lib/Constants';
export const getTeamsForUser = (userId, teamsInfo) => Object.values(getFlattenedTeamsMap(teamsInfo)).filter(team => team.userIds.includes(userId) || team.secondaryUserIds.includes(userId)).map(team => team.id);
export const getAccountsForUser = (userId, teamsInfo, adAccounts) => {
  const teamsForUser = getTeamsForUser(userId, teamsInfo);
  return adAccounts.filter(account => account.adAccountAssignees.length === 0 || account.adAccountAssignees.find(assignee => assignee.id === userId && assignee.assigneeType === USERS_AND_TEAMS_TYPE.USER || teamsForUser.includes(assignee.id) && assignee.assigneeType === USERS_AND_TEAMS_TYPE.TEAM));
};